<div class="gw-shell">

  <!-- Header -->
  <div class="gw-header">
    <div class="gw-header-content">
      <div class="gw-title">
        <mat-icon>assignment_turned_in</mat-icon>
        <span>Informe de generación de retiros</span>
      </div>

      <button type="button" class="gw-close-btn" (click)="close()" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Loading -->
  <div class="gw-loading" *ngIf="loading">
    <mat-spinner diameter="36"></mat-spinner>
    <span>Cargando informe...</span>
  </div>

  <!-- Error -->
  <div class="gw-error" *ngIf="!loading && loadError">
    <mat-icon>error_outline</mat-icon>
    <div>
      <strong>No se pudo cargar el informe.</strong>
      <span>Intenta nuevamente o valida el documento procesado.</span>
    </div>
  </div>

  <div class="gw-body" *ngIf="!loading && !loadError">

    <!-- Resumen -->
    <div class="gw-summary-grid">
      <div class="gw-summary-card">
        <span class="gw-summary-label">Total registros</span>
        <strong>{{ totalRows }}</strong>
      </div>

      <div class="gw-summary-card gw-summary-card--success">
        <span class="gw-summary-label">Creados</span>
        <strong>{{ createdRows }}</strong>
      </div>

      <div class="gw-summary-card gw-summary-card--error">
        <span class="gw-summary-label">No creados</span>
        <strong>{{ notCreatedRows }}</strong>
      </div>
    </div>

    <!-- Archivo cargado -->
    <div class="gw-file-card">
      <div class="gw-file-icon">
        <mat-icon>table_view</mat-icon>
      </div>

      <div class="gw-file-info">
        <span class="gw-file-name-label">Archivo cargado</span>
        <strong class="gw-file-name">{{ fileName }}</strong>
        <span class="gw-file-date">
          Cargado el {{ showDateInfo(fileDate) }}
        </span>
      </div>

      <button
        type="button"
        class="gw-file-action"
        *ngIf="fileUrl"
        (click)="openUploadedFile()">
        <mat-icon>visibility</mat-icon>
        Ver archivo
      </button>
    </div>

    <!-- Toolbar -->
    <div class="gw-toolbar">
      <div class="gw-search">
        <mat-icon>search</mat-icon>
        <input
          type="text"
          placeholder="Buscar por persona, documento, empleador o motivo"
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchChange()"
          [ngModelOptions]="{ standalone: true }">
      </div>

      <div class="gw-status-filters">
        <span>Estado:</span>

        <button
          type="button"
          class="gw-chip"
          [class.gw-chip--active]="statusFilter === 'ALL'"
          (click)="setStatusFilter('ALL')">
          Todos
        </button>

        <button
          type="button"
          class="gw-chip"
          [class.gw-chip--success]="statusFilter === 'CREATED'"
          (click)="setStatusFilter('CREATED')">
          Creados
        </button>

        <button
          type="button"
          class="gw-chip"
          [class.gw-chip--error]="statusFilter === 'NOT_CREATED'"
          (click)="setStatusFilter('NOT_CREATED')">
          No creados
        </button>
      </div>
    </div>

    <!-- Tabla desktop/tablet -->
    <div class="gw-table-wrap" *ngIf="pagedReport.length > 0">
      <table mat-table [dataSource]="pagedReport" class="gw-table">

        <!-- Persona -->
        <ng-container matColumnDef="person">
          <th mat-header-cell *matHeaderCellDef>Persona</th>
          <td mat-cell *matCellDef="let row">
            <div class="gw-person-cell">
              <div class="gw-avatar">
                <img
                  *ngIf="row.PersonalPhoto"
                  [src]="s3Bucket+row.PersonalPhoto"
                  [alt]="row.fullName"
                  (error)="onImageError(row)">
                <mat-icon *ngIf="!row.PersonalPhoto">person</mat-icon>
              </div>

              <div class="gw-main-info">
                <strong>{{ row.fullName }}</strong>
                <span>{{ row.documentType }} {{ row.documentNumber }}</span>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- Empleador -->
        <ng-container matColumnDef="employer">
          <th mat-header-cell *matHeaderCellDef>Empleador</th>
          <td mat-cell *matCellDef="let row">
            <div class="gw-main-info">
              <strong>{{ row.employerName }}</strong>
              <span>{{ row.employerDocumentType }} {{ row.employerDocumentNumber }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Fecha retiro -->
        <ng-container matColumnDef="terminationDate">
          <th mat-header-cell *matHeaderCellDef>Fecha retiro</th>
          <td mat-cell *matCellDef="let row">
            {{ showDateInfo(row.terminationDate)}}
          </td>
        </ng-container>

        <!-- Estado -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let row">
            <span
              class="gw-badge"
              [class.gw-badge--success]="row.created"
              [class.gw-badge--error]="!row.created">
              <mat-icon>{{ row.created ? 'check_circle' : 'cancel' }}</mat-icon>
              {{ row.created ? 'CREADO' : 'NO CREADO' }}
            </span>
          </td>
        </ng-container>

        <!-- Motivo -->
        <ng-container matColumnDef="failReason">
          <th mat-header-cell *matHeaderCellDef>Motivo</th>
          <td mat-cell *matCellDef="let row">
            <span class="gw-fail-reason" *ngIf="!row.created && row.failReason">
              {{ row.failReason }}
            </span>
            <span class="gw-muted" *ngIf="row.created || !row.failReason">—</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns; trackBy: trackByRow"></tr>
      </table>
    </div>

    <!-- Tarjetas móvil -->
    <div class="gw-card-list" *ngIf="pagedReport.length > 0">
      <div class="gw-person-card" *ngFor="let row of pagedReport; trackBy: trackByRow">

        <div class="gw-person-card-header">
          <div class="gw-avatar">
            <img
              [src]="s3Bucket+row.PersonalPhoto"
              [alt]="row.fullName"
              (error)="onImageError(row)">
            <mat-icon *ngIf="!row.PersonalPhoto">person</mat-icon>
          </div>

          <div class="gw-person-card-info">
            <strong>{{ row.fullName }}</strong>
            <span>{{ row.documentType }} {{ row.documentNumber }}</span>
          </div>

          <span
            class="gw-badge"
            [class.gw-badge--success]="row.created"
            [class.gw-badge--error]="!row.created">
            {{ row.created ? 'CREADO' : 'NO CREADO' }}
          </span>
        </div>

        <div class="gw-card-fields">
          <div>
            <span>Empleador</span>
            <strong>{{ row.employerName }}</strong>
          </div>

          <div>
            <span>Doc. empleador</span>
            <strong>{{ row.employerDocumentType }} {{ row.employerDocumentNumber }}</strong>
          </div>

          <div>
            <span>Fecha retiro</span>
            <strong>{{ showDateInfo(row.terminationDate) }}</strong>
          </div>
        </div>

        <div class="gw-reason-box" *ngIf="!row.created && row.failReason">
          <span>Motivo</span>
          <strong>{{ row.failReason }}</strong>
        </div>

      </div>
    </div>

    <!-- Vacío -->
    <div class="gw-empty" *ngIf="pagedReport.length === 0">
      <mat-icon>search_off</mat-icon>
      <strong>No se encontraron registros</strong>
      <span>Prueba cambiando el filtro de estado o el texto de búsqueda.</span>
    </div>

    <!-- Paginación -->
    <div class="gw-pagination" *ngIf="totalFiltered > 0">
      <span class="gw-pagination-range">
        Mostrando {{ rangeStart }} a {{ rangeEnd }} de {{ totalFiltered }} registros
      </span>

      <div class="gw-pagination-controls">
        <button
          type="button"
          class="gw-page-arrow"
          [disabled]="pageIndex === 0"
          (click)="prevPage()">
          <mat-icon>chevron_left</mat-icon>
        </button>

        <ng-container *ngFor="let page of visiblePages">
          <span *ngIf="page === '...'" class="gw-page-ellipsis">...</span>

          <button
            *ngIf="page !== '...'"
            type="button"
            class="gw-page-number"
            [class.gw-page-number--active]="isCurrentPage(page)"
            (click)="goToPage(page)">
            {{ page }}
          </button>
        </ng-container>

        <button
          type="button"
          class="gw-page-arrow"
          [disabled]="pageIndex >= totalPages - 1"
          (click)="nextPage()">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>

  </div>

  <!-- Footer -->
  <div class="gw-footer">
    <button mat-button class="gw-btn-close" (click)="close()">Volver a actualizaciones</button>
  </div>

</div>
